<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Konfigurator importu wpłat z wyciągu <small class="text-red-400 text-xs">(Wszystkie pola wymagane)</small></h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-3/4">

        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <multiselect-input v-model="form.firma" :error="form.errors.firma" class="pr-6 pb-8 w-full" :options="firmy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Firma importująca wpłaty" :isDisabled="true" />

            <multiselect-input v-model="form.uzytkownik" :error="form.errors.uzytkownik" class="pr-6 pb-8 w-full lg:w-1/2" :options="uzytkownicy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Użytkownik" />

            <multiselect-input v-model="form.pracownik" :error="form.errors.pracownik" class="pr-6 pb-8 w-full lg:w-1/2" :options="pracownicy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Pracownik" />

            <multiselect-input v-model="form.rachunek" :error="form.errors.rachunek" class="pr-6 pb-8 w-full lg:w-1/2" :options="rachunki" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Rachunek bankowy firmy" />

            <multiselect-input v-model="form.magazyn" :error="form.errors.magazyn" class="pr-6 pb-8 w-full lg:w-1/2" :options="magazyny" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Magazyn" />

            <multiselect-input v-model="form.typ_platnika" :error="form.errors.typ_platnika" class="pr-6 pb-8 w-full lg:w-1/2" :options="typy_platnikow" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Typ płatnika" />

            <multiselect-input v-model="form.czy_r" :error="form.errors.czy_r" class="pr-6 pb-8 w-full lg:w-1/2" :options="rozliczenia" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Rozliczanie pozycji" />

            <multiselect-input v-model="form.typ_dok_fin" :error="form.errors.typ_dok_fin" class="pr-6 pb-8 w-full lg:w-1/2" :options="typy_dok_fin" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Typ dokumentu finansowego - wpłaty" />

            <multiselect-input v-model="form.typ_dok_fin_roz" :error="form.errors.typ_dok_fin_roz" class="pr-6 pb-8 w-full lg:w-1/2" :options="typy_dok_fin" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Typ dokumentu finansowego - Rozliczenia" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['update configs']">
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zapisz konfigurację</loading-button>
          </div>
            
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Konfigurator importu wpłat' },
  components: {
    LoadingButton,
    MultiselectInput
  },
  layout: Layout,
  remember: 'form',
  props: {
    config: Object,
    firmy: Array,
    uzytkownicy: Array,
    pracownicy: Array,
    typy_dok_fin: Array,
    magazyny: Array,
    rachunki: Array
  },
  data() {
    return {
      form: this.$inertia.form({
        firma: this.config.firma,
        uzytkownik: this.config.uzytkownik,
        pracownik: this.config.pracownik,
        typ_dok_fin: this.config.typ_dok_fin,
        magazyn: this.config.magazyn,
        rachunek: this.config.rachunek,
        typ_platnika: this.config.typ_platnika,
        czy_r: this.config.czy_r,
        typ_dok_fin_roz: this.config.typ_dok_fin_roz,
      }),
      typy_platnikow: [
      	{id: 'k', name: 'kontrahent'}, {id: 'p', name: 'pracownik'}, {id: 'u', name: 'urząd'}
      ],
      rozliczenia: [
      	{id: 0, name: 'Standardowa pozycja (bez rozliczenia)'}, {id: 1, name: 'Zaliczka'}, {id: 2, name: 'Rozliczenie innego rozrachunku'}
      ]
    }
  },
  methods: {
    update() {
      this.form.put(this.route('bank_statements.config.update'))
    },
  },
}
</script>
